export default __webpack_public_path__ + "static/media/activity1.e2ce234d.jpg";